import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import { AccountServiceProxy, ResetPasswordRequestInputModule } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';
import { ResetPasswordRequestInput } from './../../../../../../shared/service-proxies/service-proxies';

@Component({
  selector: 'kt-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends AppComponentBase implements OnInit {

  loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public email : string = '' ;

  constructor(
    injector : Injector,
    private _accountService : AccountServiceProxy
  ) {
    super(injector);
  }

  ngOnInit() {
  }

  submit(){
    
    //return ;
    this.loading$.next(true);

    var input : ResetPasswordRequestInput = new ResetPasswordRequestInput();
    input.emailAddress = this.email ;
    input.module = ResetPasswordRequestInputModule.Platom_Portal;

    //Buradaki, localhost:4200 kismi, sabit bir environment dosyasindan okunmali.
    input.returnUrl = 'http://localhost:4200/reset-password';

    

    this._accountService.resetPasswordRequest(input)
      .subscribe(result =>{
        this.loading$.next(false);
        this.uiMessage.modal.success('Ok','Yeni şifre için bağlantı linki mail adresinize gönderildi', null);
      },()=>{
          //Error
          this.loading$.next(false);
      },
      () =>{
        //Complete
      }
      );
  }

}
